"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Radium = require("radium");
var react_1 = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'A customized modal.';
var code = "import React from 'react';\nimport { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'jsc-react-ui';\n\nconst styles = {\n  modal: {\n    width: 500,\n    height: 400,\n    backgroundColor: '#fff',\n    flexDirection: 'column',\n  },\n  input: {\n    border: 'none',\n    fontWeight: 600,\n    fontSize: '1.1em',\n    flex: 1,\n  } as CSSProperties,\n  textarea: {\n    border: 'none',\n    resize: 'none',\n    flex: 1,\n  },\n};\n\nclass Example extends React.Component {\n  state = {\n    modalOpen: false,\n  };\n\n  render() {\n    const { modalOpen } = this.state;\n\n    return (\n      <div>\n        <Button\n          onClick={this.handleButtonClick}\n        >\n          Open custom modal\n        </Button>\n\n        <Modal\n          style={styles.modal}\n          noBackdrop\n          open={modalOpen}\n          onClose={this.handleOnModalClose}\n        >\n          <ModalHeader>\n            <input\n              style={styles.input}\n              type=\"text\"\n              placeholder=\"Title here\"\n            />\n          </ModalHeader>\n\n          <ModalBody>\n            <textarea\n              style={styles.textarea}\n              placeholder=\"Note content here\"\n            />\n          </ModalBody>\n\n          <ModalFooter>\n            <Button flat onClick={this.handleOnModalClose}>Save</Button>\n          </ModalFooter>\n        </Modal>\n      </div>\n    );\n  }\n\n  handleButtonClick = () => {\n    this.setState({modalOpen: true});\n  }\n\n  handleOnModalClose = () => {\n    this.setState({modalOpen: false});\n  }\n}";
var styles = {
    modal: {
        width: 500,
        height: 400,
        backgroundColor: '#fff',
        flexDirection: 'column',
    },
    input: {
        border: 'none',
        fontWeight: 600,
        fontSize: '1.1em',
        flex: 1,
    },
    textarea: {
        border: 'none',
        resize: 'none',
        flex: 1,
    },
};
var CustomExample = (function (_super) {
    __extends(CustomExample, _super);
    function CustomExample() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            modalOpen: false,
        };
        _this.handleButtonClick = function () {
            _this.setState({ modalOpen: true });
        };
        _this.handleOnModalClose = function () {
            _this.setState({ modalOpen: false });
        };
        return _this;
    }
    CustomExample.prototype.render = function () {
        var modalOpen = this.state.modalOpen;
        return (React.createElement(common_1.Example, { title: "Custom", description: description, code: code },
            React.createElement(components_1.Button, { onClick: this.handleButtonClick }, "Open custom modal"),
            React.createElement(components_1.Modal, { style: styles.modal, noBackdrop: true, open: modalOpen, onClose: this.handleOnModalClose },
                React.createElement(components_1.ModalHeader, null,
                    React.createElement("input", { style: styles.input, type: "text", placeholder: "Title here" })),
                React.createElement(components_1.ModalBody, null,
                    React.createElement("textarea", { style: styles.textarea, placeholder: "Note content here" })),
                React.createElement(components_1.ModalFooter, null,
                    React.createElement(components_1.Button, { flat: true, onClick: this.handleOnModalClose }, "Save")))));
    };
    CustomExample = __decorate([
        Radium
    ], CustomExample);
    return CustomExample;
}(react_1.PureComponent));
exports.CustomExample = CustomExample;



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ModalPage/CustomExample.tsx
// module id = 699
// module chunks = 0